import React from 'react';
import PropTypes from 'prop-types';
import { CommonChrome } from '@solarwinds-cloud/cloud-ui';
import SearchResult from './search-result';

class SearchResults extends React.Component {
  static propTypes = {
    getItemProps: PropTypes.func.isRequired,
    groups: PropTypes.arrayOf(PropTypes.object),
    highlightedIndex: PropTypes.number,
    maxResults: PropTypes.number,
    savedSearches: PropTypes.arrayOf(PropTypes.object),
    sources: PropTypes.arrayOf(PropTypes.object),
    searchPhrase: PropTypes.string,
  };

  static defaultProps = {
    groups: [],
    savedSearches: [],
    sources: [],
  };

  renderSection(items, title, indexOffset) {
    const {
      highlightedIndex,
      getItemProps,
      maxResults,
      searchPhrase,
    } = this.props;
    let notice;

    if (items.length > maxResults) {
      // max results have been exceeded, so display notice
      notice = `Only displaying ${maxResults} results. Try narrowing your search.`;

      // adjust items array to match max results
      items = [...items].slice(0, maxResults);
    }

    return (
      <CommonChrome.NavSearch.Section>
        <CommonChrome.NavSearch.Header title={title} count={items.length} notice={notice} />
        {items.map((item, itemIndex) => {
          const index = itemIndex + indexOffset;

          return (
            <SearchResult
              key={index}
              getItemProps={getItemProps}
              index={index}
              item={item}
              isSelected={highlightedIndex === index}
              searchPhrase={searchPhrase}
            />
          );
        })}
      </CommonChrome.NavSearch.Section>
    );
  }

  render() {
    const { groups, savedSearches, sources } = this.props;
    const hasResults = groups.length || savedSearches.length || sources.length;

    if (!hasResults) return 'No Results';

    let indexOffset = 0;
    let groupsSection, savedSearchesSection, sourcesSection;

    if (groups.length) {
      groupsSection = this.renderSection(groups, 'Groups', indexOffset);
      indexOffset += groups.length;
    }

    if (savedSearches.length) {
      savedSearchesSection = this.renderSection(
        savedSearches,
        'Saved Searches',
        indexOffset
      );
      indexOffset += savedSearches.length;
    }

    if (sources.length) {
      sourcesSection = this.renderSection(sources, 'Systems', indexOffset);
    }

    return (
      <React.Fragment>
        {groupsSection}
        {savedSearchesSection}
        {sourcesSection}
      </React.Fragment>
    );
  }
}

export default SearchResults;
